import { Menu, Plus } from "lucide-react";
import { useTaskStore } from "../stores/taskStore";
import { useUiStore } from "../stores/uiStore";
import { useSyncStore } from "../stores/syncStore";
import { clsx } from "clsx";
import { GlobalSearchButton } from "./GlobalSearch";

interface Props {
  onMenuClick: () => void;
}

export function MobileHeader({ onMenuClick }: Props) {
  const stats = useTaskStore((s) => s.stats);
  const filter = useTaskStore((s) => s.filter);
  const setEditorOpen = useUiStore((s) => s.setEditorOpen);
  const status = useSyncStore((s) => s.status);
  const labels = { today: "今日", active: "未完了", all: "全部", completed: "完了", high: "高優先", trashed: "ゴミ箱" };
  // D1 クラウド同期の実態（state + lastSyncAt）で同期ドットを出す。
  const hasSynced = Boolean(status.lastSyncAt && status.state !== "error");
  const dot =
    status.state === "error"
      ? "bg-danger-500"
      : status.state === "syncing"
      ? "bg-warning-500"
      : hasSynced
      ? "bg-success-500"
      : "bg-dim";

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-border bg-card/95 px-4 backdrop-blur dark:border-border-dark dark:bg-card-dark/95 md:hidden">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="メニューを開く"
        className="flex h-11 w-11 items-center justify-center rounded-md text-text dark:text-text-dark"
      >
        <Menu className="h-5 w-5" />
      </button>
      <div className="flex flex-1 flex-col items-center">
        <div className="flex items-center gap-1.5 text-base font-semibold">
          {labels[filter]}
        </div>
        <div className="flex items-center gap-1 text-[10px] text-muted dark:text-muted-dark">
          <span className={clsx("h-1.5 w-1.5 rounded-full", dot)} />
          {status.state === "syncing"
            ? "同期中"
            : status.state === "error"
            ? "同期エラー"
            : `アクティブ ${stats.active}`}
        </div>
      </div>
      <div className="flex items-center gap-1">
        <GlobalSearchButton className="h-11 w-11 border-0" />
        <button
          type="button"
          onClick={() => setEditorOpen(true)}
          aria-label="新規タスク"
          className="flex h-11 w-11 items-center justify-center rounded-md bg-brand-500 text-white"
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
